module.exports = __webpack_public_path__ + "img/01.519ccb7c.png";